/**
 *
 *
 *
 *
 */
export function jsonParseSafe(value) {
    try {
        return typeof value === "string" ? JSON.parse(value) : undefined;
    }
    catch {
        return undefined;
    }
}
/**
 *
 *
 *
 *
 */
export const jsonParseOrUse = (value) => jsonParseSafe(value) ?? value;
